import { Component, Prop } from 'vue-property-decorator';
import { MenuEntry } from '@cms/interfaces/menu-entry';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import BpcPublicMenuEntry from '@cms/components/public-menu-entry/public-menu-entry.vue';
import Vue from 'vue';

@Component({
  name: 'bpc-public-menu',
  components: {
    'bpc-public-menu-entry': BpcPublicMenuEntry,
  },
})
export default class PublicMenu extends Vue {
  @Prop(String) readonly logo: string;
  @Prop(String) readonly name: string;

  public menuEntries: MenuEntry[] = [];
  public loading: boolean = false;
  public menuEntriesSubscription = null;

  mounted() {
    this.getMenuEntries();
  }

  public getMenuEntries(): void {
    this.loading = true;

    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('menu-entries', 'raw')}`;

    const queryConfig = {
      params: {
        published: 1,
        orderBy: 'ordering',
        orderDirection: 'asc',
      },
    };

    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(
      fetchEntityPath,
      queryConfig,
      'public',
    );

    if (this.menuEntriesSubscription) {
      this.menuEntriesSubscription.unsubscribe();
    }

    this.menuEntriesSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.menuEntries = this.buildHierarchicalMenu(res.data) || [];
        this.loading = false;
      },
      error => {
        console.log(error);
        this.loading = false;
      },
    );
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'];
  }

  get useNewCMS(): boolean {
    return this.$store.getters['centerSettings/centerSettings']?.use_new_cms;
  }

  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  public menuEntryProfileRoute(profile_name: string) {
    this.$router.replace({ name: profile_name });
  }

  get isLoggedIn(): boolean {
    return this.$authService.isLoggedIn();
  }

  buildHierarchicalMenu(menuEntries) {
    const menu = [];
    let mainIndex = 0;
    let subIndex = 0;
    menuEntries.forEach(entry => {
      entry['submenu'] = [];
      if (!entry['menu_level']) {
        menu.push(entry);
        mainIndex++;
        subIndex = 0;
      } else if (entry['menu_level'] === 1) {
        menu[mainIndex - 1]['submenu'].push(entry);
        subIndex++;
      } else if (entry['menu_level'] === 2) {
        menu[mainIndex - 1]['submenu'][subIndex - 1]['submenu'].push(entry);
      }
    });
    return menu;
  }

  canAccess(menuEntry) {
    return (
      menuEntry.access == 'all' ||
      (menuEntry.access == 'private' && this.isLoggedIn) ||
      (menuEntry.access == 'public' && !this.isLoggedIn)
    );
  }

  menuEntryNewCmsUrl(menuEntry: MenuEntry): string {
    const protocol = window.location.protocol;
    const domain = this.$clientRouter.getTenantDomain(this.tenantAlias);
    return `${protocol}//${domain}/web/${this.lang}/page/${menuEntry.post?.alias}`;
  }

  /* Lifecycle hooks */

  // created() {}
  // updated() {}
  // destroyed() {}
}
